import queryString from "query-string";

export const getUrlParams = (queryParams) => {
    const search = queryString.stringify(queryParams);
    return search ? `?${search}` : "";
};

export const getUrl = (path, queryParams) => (`${path}${getUrlParams(queryParams)}`);